import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import _ from "lodash";

import { Item } from "./Item";

export function SortableItem(props) {
  const {
    attributes,
    isDragging,
    isSorting,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: props.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Item
        item={props.item}
        id={props.id}
        index={props.index}
        isDragging={isDragging}
        isSorting={isSorting}
        type={props.type}
        handleRemoveFromSlide={props.handleRemoveFromSlide}
        feedType={props.feedType}
        countries={props.countries}
      />
    </div>
  );
}
